import { logEvent } from "@/utils/logEvent";

const CRUD_ACTIONS = ["create", "update", "delete"];

export default function vuexLogger(store) {
  store.subscribeAction({
    after: async (action, state) => {
      const type = action.type.toLowerCase();
      const crud = CRUD_ACTIONS.find((c) => type.includes(c));
      if (crud) {
        await logEvent({
          action: type,
          feature: action.type.split("/")[0], // e.g., 'user', 'claim'
          status: "success",
          meta: { payload: action.payload },
          user: state.auth?.user,
        });
      }
    },
    error: async (action, state, error) => {
      const type = action.type.toLowerCase();
      const crud = CRUD_ACTIONS.find((c) => type.includes(c));
      if (crud) {
        await logEvent({
          action: type,
          feature: action.type.split("/")[0],
          status: "failure",
          meta: { payload: action.payload, error: error?.message },
          user: state.auth?.user,
        });
      }
    },
  });
}
